import React from 'react';

// Stock.set_type is stored as "", "None", "Primary" or "Telco". Both empty
// spellings mean "no set type" and show as "None" - the word the Stock page's
// Set Type column and its filter use for that case, so what a user reads on
// the pill is also what they pick in the Set Type filter to find it.
export function normalizeSetType(value) {
    const v = String(value ?? '').trim();
    return !v || v.toLowerCase() === 'none' ? 'None' : v;
}

/**
 * ERP-5160 — the Condition / Condition Type / Set Type pill row shared by every
 * screen that shows a Stock. Renders bare spans so the caller keeps its own flex
 * wrapper, and takes the caller's pill className/style so each screen keeps the
 * sizing it already had.
 */
export default function StockTags({ condition, conditionType, setType, className = 'status', style }) {
    const setTypeTag = normalizeSetType(setType);
    return (
        <>
            {condition ? <span className={className} style={style}>{condition}</span> : null}
            {conditionType ? <span className={className} style={style}>{conditionType}</span> : null}
            <span className={className} style={style}>{setTypeTag}</span>
        </>
    );
}
